<ng-template #popTemplate>
    <div class="footer__update-tooltip">
        <span>Theatre: {{lastTheatreImport}}</span>
        <span>PTL: {{lastPtlImport}}</span>
        <span>PAS: {{lastPasImport}}</span>
    </div>
</ng-template>
<div>
    <footer class="footer">
        <div class="footer__container">
            <div>
                <img class="footer__logo" [src]="fourEyesLogo" alt="logo" />
            </div>
            <div class="footer__imports" [tooltip]="popTemplate">
                <span>
                    Latest update: {{lastImport}}
                </span>
            </div>
            <div>
                <span class="footer__version">
                    Insight
                    <span
                        *ngIf="appSession.tenant && appSession.tenant.edition && appSession.tenant.edition.displayName">
                        {{appSession.tenant.edition.displayName}}</span>
                    <br /> v{{appSession.application.version}} [{{releaseDate}}]
                </span>
            </div>
        </div>
    </footer>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/layout/footer.component.html